/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Store", "../FluxCommon/ActionsHubManager", "./ImageDetailsActions", "../Constants"], function (require, exports, Store_1, ActionsHubManager_1, ImageDetailsActions_1, Constants_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ImageDetailsStore = /** @class */ (function (_super) {
        __extends(ImageDetailsStore, _super);
        function ImageDetailsStore() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._setHasImageDetailsData = function (payload) {
                if (payload) {
                    _this._hasImageDetails = payload;
                    _this.emit(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, _this);
                }
            };
            _this._setImageDetailsData = function (payload) {
                if (payload && payload.imageName) {
                    _this._imageDetails[payload.imageName] = payload;
                    _this.emit(Constants_1.ImageDetailsEvents.SetImageDetailsEvent, _this);
                }
            };
            _this._hasImageDetails = {};
            _this._imageDetails = {};
            return _this;
        }
        ImageDetailsStore.getKey = function () {
            return "image-details-store";
        };
        ImageDetailsStore.prototype.initialize = function (instanceId) {
            _super.prototype.initialize.call(this, instanceId);
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(ImageDetailsActions_1.ImageDetailsActions);
            this._actions.setHasImageDetails.addListener(this._setHasImageDetailsData);
            this._actions.setImageDetails.addListener(this._setImageDetailsData);
        };
        ImageDetailsStore.prototype.disposeInternal = function () {
            this._actions.setHasImageDetails.removeListener(this._setHasImageDetailsData);
            this._actions.setImageDetails.removeListener(this._setImageDetailsData);
        };
        ImageDetailsStore.prototype.hasImageDetails = function (imageName) {
            return this._hasImageDetails[imageName];
        };
        ImageDetailsStore.prototype.getImageDetails = function (imageName) {
            return this._imageDetails[imageName];
        };
        return ImageDetailsStore;
    }(Store_1.StoreBase));
    exports.ImageDetailsStore = ImageDetailsStore;
});
